import React from "react";
import "./search-input.css";

function Searchinput(props) {
  const { id, title, onChange, showSideArrrow } = props;
  const debounce = (func, wait) => {
    let timeout;

    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };

      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  const handleInputSearchChange = debounce(function (event) {
    onChange(event);
  }, 1000);

  const handleOnClick = () => {
    if (props?.onClick) {
      props?.onClick();
    }
  };

  return (
    <>
     
      <div className="search-input">
        <input
          id={id}
          type="text"
          className="form-control"
          width={80} placeholder={title}
          // value={value}
          onChange={handleInputSearchChange}
        />
        <i className="material-icons" onClick={handleOnClick}>
          {showSideArrrow ? "keyboard_arrow_right" : "search"}
        </i>
      </div>

    </>
  );
}

export default Searchinput;
